import { render, staticRenderFns } from "./QuestionVideoPlayer.vue?vue&type=template&id=a4179abc&"
import script from "./QuestionVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./QuestionVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionVideoPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports